import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    
    // Remove all non-digit characters
    const cleaned = value.replace(/\D/g, '');
    
    // Handle different lengths
    if (cleaned.length === 10) {
      // Format as (XXX) XXX-XXXX
      return `(${cleaned.substring(0, 3)}) ${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
    } else if (cleaned.length === 11 && cleaned.startsWith('1')) {
      // Handle +1 country code - format as +1 (XXX) XXX-XXXX
      return `+1 (${cleaned.substring(1, 4)}) ${cleaned.substring(4, 7)}-${cleaned.substring(7)}`;
    } else if (cleaned.length === 7) {
      // Local number format XXX-XXXX
      return `${cleaned.substring(0, 3)}-${cleaned.substring(3)}`;
    }
    
    // If it doesn't match standard lengths, return formatted with dashes at reasonable intervals
    if (cleaned.length > 0) {
      if (cleaned.length <= 3) return cleaned;
      if (cleaned.length <= 6) return `${cleaned.substring(0, 3)}-${cleaned.substring(3)}`;
      return `${cleaned.substring(0, 3)}-${cleaned.substring(3, 6)}-${cleaned.substring(6)}`;
    }
    
    // If no digits found, return original
    return value;
  }
}